import * as React from 'react';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import { SiteUrls } from '@tableau/shared-urls';
import * as CertificationWatermark from '@tableau/certification-watermark';
import { databasesWithCrassCellFormatters } from '@tableau/data-catalog-client-components';
import { CertificationCell } from './CertificationCell';
import { IColumnFactoryParameters } from '../ListViewGridColumnGenerator';
import * as Layout from '../../../../common/styles/Layout';
import { generateDBAndTableCertificationTooltipProps, IconStyle } from '../../../utils/DataCatalogUtils';

export function DatabaseNameCell(parameters: IColumnFactoryParameters): React.Factory<BodyCell.Props> {
  return React.createFactory(function TableNameCell(props: BodyCell.Props) {
    const nameFactory = databasesWithCrassCellFormatters.name.cellFormatter;
    const typeFactory = databasesWithCrassCellFormatters.typeForCrass.cellFormatter;
    const certificationFactory = CertificationCell(parameters.listViewParams.urls, {
      isCertified: (row: DataGrid.Row) => row.data.isCertified,
      getTooltipProps: (row: DataGrid.Row, urls: SiteUrls): CertificationWatermark.CertificationTooltipProps => {
        return generateDBAndTableCertificationTooltipProps(row, urls);
      },
    });
    const dataQualityWarningFactory = databasesWithCrassCellFormatters.dataQualityWarning.cellFormatter;

    // the nameFactory in data-catalog-client-components need to use id with GraphQL id to generate the link.
    // so here we have to assign id ot the GraphQL id.
    props.row.data.id = props.row.data.graphQLId;

    return (
      <div className={Layout.flexH} style={{ width: '100%' }}>
        <div className={IconStyle}>{typeFactory(props)}</div>
        <div className={IconStyle}>{certificationFactory(props)}</div>
        <div className={IconStyle}>{dataQualityWarningFactory(props)}</div>
        <div className={Layout.flexAuto} style={{ overflow: 'hidden' }}>
          {nameFactory(props)}
        </div>
      </div>
    );
  });
}
